export default __webpack_public_path__ + "static/media/efl-iconfont.4472c836.ttf";